import { useMemo } from "react";
import { useSelector } from "react-redux";
import { QuestState } from "../types/quests/indext";
import { isListedQuest } from "../utils/quest-list";

// Quests that are done but not yet claimed, counted from the stored quest list
// (refreshed by useQuests().getQuests). Drives the "reward waiting" badges, so
// it counts only what the quest list shows (isListedQuest).
export default function useClaimableQuestCount(): number {
  const quests = useSelector((state: any) => state.quests);
  return useMemo(
    () =>
      Array.isArray(quests)
        ? quests.filter((quest) => isListedQuest(quest) && quest?.state === QuestState.Done).length
        : 0,
    [quests]
  );
}
